import { HttpRequest } from "@azure/functions";

export const getQueryParamOrThrowError = (req: HttpRequest, param: string) => {
    const value = req.query.get(param)
    if (!value) {
        throw new Error(`Missing query param: "${param}"`)
    }
    return value
}
